package com.example.mystybag.sharedmodels

@Suppress("VARIABLE_IN_SINGLETON_WITHOUT_THREAD_LOCAL")
object ModelsData {
    var command                 = 0
    var version                 = ""
    var versionName             = ""
    var walletProduct           = ""
    var ip                      = ""
    var os                      = 0
    var language                = "en"
    var osVersionCode           = ""
    var session                 = ""
    var resourceId              = ""
    var deviceModel             = ""
    var extraData               = ""
    var accessToken             = ""
    var registrantId            = ""
    var countryISO3             = ""
    var appKey                  = ""
}